import React, { useState } from "react";

const ShowButton = ({
  color,
  positionBottom,
  positionLeft,
  positionRight,
  positionTop,
  onClick,
  description,
  show,
  fontColor,
}) => {
  const [hover, setHover] = useState(false);

  const colorObj = {
    red: "#ff0000",
    brown: "#9a4602",
    green: "#00ff00",
    blue: "#bbe3f0",
    null: "white",
  };
  return (
    <div
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
      onClick={() => {
        if (onClick) onClick(show);
      }}
      style={{
        opacity: hover ? "80%" : "50%",
        width: "150px",
        height: "150px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: "2px solid black",
        borderRadius: "1rem/1rem",
        backgroundColor: colorObj[color],
        position: "absolute",
        bottom: positionBottom,
        left: positionLeft,
        right: positionRight,
        top: positionTop,
      }}
    >
      <div className="textBoldWhite" style={{ color: fontColor }}>
        {description}
      </div>
    </div>
  );
};

export default ShowButton;
